import { createApp } from 'vue'
//import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/scss/app.scss'
//import vueBulmaComponente from 'vue-bulma-components'
import 'bulma/css/bulma.css'
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyAfB6PXt7k10qy2Mt6BI2SdhUFhX2SrQO0",
    authDomain: "manonest.firebaseapp.com",
    projectId: "manonest",
    storageBucket: "manonest.appspot.com",
    messagingSenderId: "385757646910",
    appId: "1:385757646910:web:d12e942b250624d519016f",
    measurementId: "G-MWN1Z8WXNZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

console.log("analytics: " + analytics)

//Vue.useContext(vueBulmaComponente)
createApp(App).use(router).mount('#app')

/*Vue.config.productionTip = false

let app
if (!app){
    app = new Vue({
        router,
        render: h => h(App)
    }).$mount('£app')
}*/